import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import 'tachyons';
import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
console.log(navigator.language);
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
